export enum UPLOAD_IMAGE_DOCUMENT_TYPES {
  account = 'account',
  admin = 'admin',
  groupBackgroundImage = 'group_background_image',
  groupWelcomePage = 'group_welcome_page_image',
  opportunity_image = 'opportunity_image',
  pathwayInvitationBody = 'pathway_invitation_body',
  programInvitationBody = 'program_invitation_body',
  programPhaseEmailBody = 'program_phase_email_body',
  tenant = 'tenant',
}

export const UPLOAD_IMAGE_URL = {
  [UPLOAD_IMAGE_DOCUMENT_TYPES.account]: '/api/account/image/portrait_original',
  [UPLOAD_IMAGE_DOCUMENT_TYPES.admin]: (accountId: string) =>
    `/api/admin/accounts/${accountId}/image/portrait_original`,
  [UPLOAD_IMAGE_DOCUMENT_TYPES.groupBackgroundImage]: (groupId: string) =>
    `/api/v2/groups/${groupId}/image/background_image`,
  [UPLOAD_IMAGE_DOCUMENT_TYPES.groupWelcomePage]:
    'api/v2/upload-image/group_welcome_page_image',
  [UPLOAD_IMAGE_DOCUMENT_TYPES.opportunity_image]:
    'api/v2/upload-image/opportunity_image',
  [UPLOAD_IMAGE_DOCUMENT_TYPES.pathwayInvitationBody]:
    'api/v2/upload-image/pathway_invitation_body',
  [UPLOAD_IMAGE_DOCUMENT_TYPES.programInvitationBody]:
    'api/v2/upload-image/program_invitation_body',
  [UPLOAD_IMAGE_DOCUMENT_TYPES.programPhaseEmailBody]:
    'api/v2/upload-image/program_phase_email_body',
  [UPLOAD_IMAGE_DOCUMENT_TYPES.tenant]: '/api/admin/tenant/image/logo',
};
